import _ from 'lodash';
import { mergeStates } from '../iwProvider/StoreHelper';
import { SET_LOCALE } from './IwIntlProvider.actions';

const initialState = {
    ready: false,
    language: '',
    locale: '',
    currency: ''
};

// eslint-disable-next-line import/no-default-export
export default function intl(state = mergeStates(initialState), action) {
    switch (action.type) {
        case SET_LOCALE:
            return mergeStates(state, {
                ready: true,
                locale: _.get(action, 'data.locale', ''),
                language: _.get(action, 'data.language', ''),
                currency: _.get(action, 'data.currency', '')
            });

        default:
            return state;
    }
}
